import { SortDirection } from '@angular/material/sort';
import { SubentityStateModel } from 'app/projects/subentity/src/lib/models/subentity.state-model';

export class AllUsersStateModel extends SubentityStateModel {
    filters = {
        list: [],
    };
    totalCount: number;
    userIds: string[];
    sortBy: string;
    sortOrder: SortDirection;
    pageSize: number;
    pageNumber: number;
    communitySearchTerm: string;

    constructor() {
        super();

        this.userIds = [];
        this.searchTerm = sessionStorage.getItem('allUsersSearchTerm');
        this.communitySearchTerm = sessionStorage.getItem('allUsersCommunitySearchTerm');
        this.sortBy = sessionStorage.getItem('allUsersSortBy');
        this.sortOrder = sessionStorage.getItem('allUsersSortOrder') as SortDirection;
    }
}
